import cx from 'classnames';
import _ from 'lodash';
import { DEFAULT_RICH_TEXT_MENU_ITEMS } from './datasets';
import css from './RichText.module.scss';
import {
  IRichTextEditorMenuProps,
  IRichTextEditorProps,
  RichTextEditor,
} from './RichTextEditor';

interface IRichTextProps {
  defaultTextAlignment?: 'left' | 'center' | 'right';
  errorMessage?: string;
  isInvalid?: boolean;
  label: string;
  maxLength?: IRichTextEditorProps['maxLength'];
  onChange: IRichTextEditorProps['onChange'];
  orderedMenuItems?: IRichTextEditorMenuProps['orderedItems'];
  placeholder?: IRichTextEditorProps['placeholder'];
  value: IRichTextEditorProps['value'];
}

export const RichText = ({
  defaultTextAlignment,
  errorMessage,
  isInvalid,
  label,
  maxLength,
  onChange,
  orderedMenuItems,
  placeholder,
  value,
}: IRichTextProps) => {
  return (
    <RichTextEditor
      defaultTextAlignment={defaultTextAlignment}
      maxLength={maxLength}
      onChange={onChange}
      placeholder={placeholder}
      value={value}
    >
      {({ editor, id }) => (
        <>
          <div className={css.labelContainer}>
            <label className={css.label} htmlFor={id}>
              {label}
            </label>
            {!!maxLength && (
              <p>
                {editor?.storage.characterCount.characters()}/{maxLength}
              </p>
            )}
          </div>
          <RichTextEditor.Menu
            className={css.menu}
            orderedItems={
              _.isEmpty(orderedMenuItems)
                ? DEFAULT_RICH_TEXT_MENU_ITEMS
                : orderedMenuItems
            }
          />
          <RichTextEditor.Content
            className={cx(css.content, { [css.invalid]: isInvalid })}
          />
          {isInvalid && <p className={css.errorMessage}>{errorMessage}</p>}
        </>
      )}
    </RichTextEditor>
  );
};
